import { z } from 'zod';

/**
 * Bot Configuration Validation Schema
 * Mirrors the BotConfig interface in src/types/bot.ts
 */
export const BotConfigSchema = z.object({
    id: z.string().uuid().or(z.literal('')), // Allow empty string for new bots
    name: z.string().min(1, "Name is required"),
    welcomeMsg: z.string().min(1, "Welcome message is required"),
    primaryColor: z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, "Invalid color format"),
    avatarEmoji: z.string(), // Could optionally be regex-validated for emoji
    position: z.enum(['left', 'right', 'bottom-left', 'bottom-right']),
    botBubbleBg: z.string(),
    botBubbleColor: z.string(),
    notes: z.string(),
    context: z.string(),
    linkedDocIds: z.array(z.string()).optional(),

    // Structured Business Context
    companyName: z.string().optional(),
    companyLocation: z.string().optional(),
    companyPhone: z.string().optional(),
    companyEmail: z.string().email("Invalid email").optional().or(z.literal('')),
    companyServices: z.string().optional(),
    botTone: z.enum(['professional', 'friendly', 'casual', 'formal']).optional(),

    // Timestamps
    createdAt: z.number(),
    updatedAt: z.number(),
});

export type BotConfig = z.infer<typeof BotConfigSchema>;

/**
 * Checkout Session Schema
 * Used when requesting a new Stripe Checkout Session
 */
export const CheckoutSessionRequestSchema = z.object({
    plan: z.enum(['starter', 'business'])
});

export type CheckoutSessionRequest = z.infer<typeof CheckoutSessionRequestSchema>;
